import React from "react";
import styled from "styled-components";
import { FormGroup, ControlLabel, HelpBlock } from "components/bootstrap";
import { Radio } from "components/common";
import { THRESHOLD_MODES } from "license/traffic/types";
const StyledControlLabel = styled(ControlLabel)`
  margin-bottom: ${({ theme }) => theme.spacings.sm};
`;
const RadioOption = styled(Radio)`
  margin-top: 0;
  margin-bottom: 0;
`;
const RadioGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings.md};
`;
const ThresholdTypeRadioSelector = ({ onChange, selectedThresholdMode }) => /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(StyledControlLabel, null, "Threshold Type"), /* @__PURE__ */ React.createElement(RadioGroup, null, /* @__PURE__ */ React.createElement(
  RadioOption,
  {
    name: "threshold_type",
    checked: selectedThresholdMode === THRESHOLD_MODES.PERCENTAGE,
    onChange: () => onChange(THRESHOLD_MODES.PERCENTAGE)
  },
  /* @__PURE__ */ React.createElement("strong", null, "Percentage (%)"),
  /* @__PURE__ */ React.createElement(HelpBlock, null, "Monitor percentage of license limit for the current billing period.")
), /* @__PURE__ */ React.createElement(
  RadioOption,
  {
    name: "threshold_type",
    checked: selectedThresholdMode === THRESHOLD_MODES.ABSOLUTE,
    onChange: () => onChange(THRESHOLD_MODES.ABSOLUTE)
  },
  /* @__PURE__ */ React.createElement("strong", null, "Absolute (in GiB)"),
  /* @__PURE__ */ React.createElement(HelpBlock, null, "Monitor absolute GiB thresholds for the current billing period.")
)));
export default ThresholdTypeRadioSelector;
